import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Ship all scanned travelers for a set of packages.
 *
 * Delegates to the shipPackageTravelersV2 callable, which marks each traveler
 * shipped and records one grouped SHIPPED inventory transaction per
 * package / line item / product version (deltaOnHand: -N with the full
 * traveler list, attributed to the caller) instead of one -1 tx per traveler.
 *
 * Warnings (missing / already-shipped / inventory-less travelers) are logged
 * for manual follow-up rather than thrown — the shipment itself already
 * succeeded by the time this runs.
 *
 * Input mirrors the trackingData structure already built in packageProvider;
 * quantityShipped is passed alongside the traveler scans so the callable can
 * flag scan-vs-qty mismatches in the tx reason:
 *   packages: [{
 *     shipmentId,
 *     lineItems: [{ lineItemId, travelerIds, quantityShipped }],
 *   }]
 *
 * @param {{
 *   packages: Array<{
 *     shipmentId: string,
 *     lineItems: Array<{
 *       lineItemId: string, travelerIds: string[], quantityShipped: number,
 *     }>,
 *   }>,
 * }} params
 * @returns {Promise<{
 *   shippedCount: number, txCount: number, warnings: string[],
 * } | null>}
 */
export default async function shipTravelersInventory({ packages }) {
  if (!packages?.length) return null;

  const shipPackageTravelers = httpsCallable(getFunctions(), 'shipPackageTravelersV2');
  const { data } = await shipPackageTravelers({ packages });
  if (data?.warnings?.length) {
    // eslint-disable-next-line no-console
    console.warn('shipPackageTravelersV2 warnings:', data.warnings);
  }
  return data;
}
